(ns quuppa.ui.modal
  (:require [reagent.core :as r]
            ["react-bootstrap/Modal$default" :as Modal]))

;; https://react-bootstrap.github.io/components/modal/

(def modal (r/adapt-react-class Modal))
(def dialog (r/adapt-react-class (.-Dialog Modal)))
(def header (r/adapt-react-class (.-Header Modal)))
(def title (r/adapt-react-class (.-Title Modal)))
(def body (r/adapt-react-class (.-Body Modal)))
(def footer (r/adapt-react-class (.-Footer Modal)))

